import { createClient } from 'contentful'
import { defineNuxtPlugin } from '#app'

let sharedClient: ReturnType<typeof createClient> | null = null
let sharedPreviewClient: ReturnType<typeof createClient> | null = null

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()

  if (!sharedClient) {
    sharedClient = createClient({
      space: config.public.CONTENTFUL_SPACE_ID,
      accessToken: config.public.CONTENTFUL_ACCESS_TOKEN,
    })
  }

  if (!sharedPreviewClient) {
    sharedPreviewClient = createClient({
      space: config.public.CONTENTFUL_SPACE_ID,
      accessToken: config.public.CONTENTFUL_PREVIEW_ACCESS_TOKEN,
      host: 'preview.contentful.com',
    })
  }

  nuxtApp.provide('contentfulClient', sharedClient)
  nuxtApp.provide('previewClient', sharedPreviewClient)
})
